// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
function use(autoplay, media, mediaKind, mediaId, param) {
  var setProgressRef = React.useRef([]);
  var match = React.useState(function () {});
  var setProgressSpeed = match[1];
  var mediaId$1 = mediaId !== undefined ? mediaId : Belt_Option.map(media, function (media) {
    return media.id;
  });
  var mediaKind$1 = mediaKind !== undefined ? mediaKind : Belt_Option.map(media, function (media) {
    return media.kind;
  });
  React.useEffect(function () {
    var exit = 0;
    if (mediaKind$1 !== undefined && !(typeof mediaKind$1 === "object" || !(mediaKind$1 === "image" && autoplay))) {
      Curry._1(setProgressSpeed, function (param) {
        return 5000;
      });
    } else {
      exit = 1;
    }
    if (exit === 1) {
      Curry._1(setProgressSpeed, function (param) {});
    }
    Belt_Array.forEach(setProgressRef.current, function (fn) {
      Curry._1(fn, undefined);
    });
  }, [mediaId$1, mediaKind$1, autoplay]);
  var setProgress = function (progress) {
    Belt_Array.forEach(setProgressRef.current, function (fn) {
      Curry._1(fn, Caml_option.some(progress));
    });
  };
  return [match[0], setProgress, setProgressRef];
}
export { use };
/* react Not a pure module */